// app.config.ts
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconRegistry } from '@angular/material/icon';
import { ApplicationConfig, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { RideWssHttpInterceptorsModule } from '@uzurv/rideWss/app/http-interceptors';
import { provideRideWssStore } from '@uzurv/rideWss/app/store/ride-wss.store.providers';
import { ClaraHttpInterceptorsModule } from '@uzurv/rideWss/clara';
import { registerIcons } from './app.icon-registry';
import { routes } from './app.routes';
import { provideRideWssTranslateInitializer, RideWssTranslateLoader } from './i18n/ride-wss-translate.providers';
import { GoogleAnalyticsResolver } from './resolvers/google-analytics.resolver';
import { MapsSdkResolver } from './resolvers/maps-sdk.resolver';
import { LogRocketService } from './services';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(
      HttpClientModule,
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        isolate: true,
        loader: {
          provide: TranslateLoader,
          useClass: RideWssTranslateLoader
        }
      }),
      RideWssHttpInterceptorsModule.forRoot(),
      ClaraHttpInterceptorsModule.forRoot(),
      BrowserAnimationsModule,
      MatDialogModule
    ),
    MapsSdkResolver,
    GoogleAnalyticsResolver,
    provideRideWssTranslateInitializer(),
    ...provideRideWssStore(),
    {
      provide: APP_INITIALIZER,
      useFactory: (matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) => () => registerIcons(matIconRegistry, domSanitizer),
      deps: [MatIconRegistry, DomSanitizer],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (logRocketService: LogRocketService) => () => logRocketService.init(),
      deps: [LogRocketService],
      multi: true
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        floatLabel: 'always',
        hideRequiredMarker: true,
        subscriptSizing: 'dynamic'
      }
    }
  ]
};
